module.exports = __webpack_public_path__ + "img/placeOfShipment.29606e57.png";